import { EnumSchema } from '../metadata-schema';

export const Instroom: EnumSchema = {
	"type": "string",
	"title": "Instroom",
	"enum": [
		"Intern",
		"Intern (tussentijds)",
		"Extern",
		"Extern (tussentijds)"
	]
};
